let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("725ea")).then(() => parcelRequire('rZPcB'));